import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Input, ContentChild, HostListener, NgModule } from '@angular/core';
import * as i3 from '@rogers/cdk/icon';
import { IconComponent, IconModule } from '@rogers/cdk/icon';
import * as i1 from '@rogers/cdk/common/services';
import * as i2 from '@rogers/cdk/common/a11y';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';

class LinkComponent {
    constructor(_element, windowService, focusMonitor) {
        this._element = _element;
        this.windowService = windowService;
        this.focusMonitor = focusMonitor;
        this.variant = 'cta';
        this.disabled = false;
        this.selected = false;
        this.focusMonitor.monitor(this.element, true);
    }
    onClick(e) {
        if (this.disabled) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
    }
    handleClick(e) {
        if (e.code === 'Space' ||
            e.key === 'Spacebar' ||
            e.code === 'Enter' ||
            e.key === 'Enter') {
            e.preventDefault();
            this.element.nativeElement.click();
            e.stopPropagation();
        }
    }
    get linkText() {
        if (this.windowService.isBrowser()) {
            return this.element.nativeElement.innerText.trim();
        }
        return this.element.nativeElement.innerText;
    }
    get element() {
        return this._element;
    }
    ngOnInit() { }
    ngOnDestroy() {
        this.focusMonitor.stopMonitoring(this.element);
    }
    showIcon() {
        return !this.iconRef && this.variant === 'cta';
    }
}
LinkComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: LinkComponent, deps: [{ token: i0.ElementRef }, { token: i1.WindowService }, { token: i2.FocusMonitor }], target: i0.ɵɵFactoryTarget.Component });
LinkComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: LinkComponent, selector: "a[ds-link]", inputs: { variant: "variant", disabled: "disabled", selected: "selected", tabIndex: "tabIndex", a11yDescription: "a11yDescription" }, host: { listeners: { "click": "onClick($event)", "keydown": "handleClick($event)" }, properties: { "class.ds-link": "true", "class.ds-pointer": "true", "class.d-inline-flex": "true", "class.outline-none": "true", "class.mw-100": "true", "class.-cta": "variant === \"cta\"", "class.-icon": "variant === \"icon\"", "class.-disabled": "disabled", "class.-selected": "selected", "class.text-no-decoration": "true", "attr.aria-current": "selected ? \"page\" : null", "attr.disabled": "disabled || null", "attr.aria-disabled": "disabled ? disabled.toString() : null", "attr.tabindex": "disabled ? -1 : tabIndex ||  0", "attr.role": "\"link\"" } }, queries: [{ propertyName: "iconRef", first: true, predicate: IconComponent, descendants: true }], ngImport: i0, template: "<span class=\"ds-link__container d-flex align-items-center\">\n  <span\n    class=\"ds-link__wrapper d-inline-block text-button\"\n    [ngClass]=\"{ 'text-bold': selected }\"\n    role=\"text\"\n  >\n    <ng-content select=\".left\"></ng-content>\n    <span class=\"ds-link__copy\">\n      <ng-content></ng-content>\n      <span *ngIf=\"a11yDescription\" class=\"sr-only\">{{ a11yDescription }}</span>\n    </span>\n    <ng-content select=\".right || ds-icon\"></ng-content>\n    <ds-icon *ngIf=\"showIcon()\" class=\"right\" name=\"right\"></ds-icon>\n  </span>\n</span>\n", components: [{ type: i3.IconComponent, selector: "ds-icon", inputs: ["name", "color", "caption", "ariaHidden", "size"] }], directives: [{ type: i4.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: LinkComponent, decorators: [{
            type: Component,
            args: [{ selector: 'a[ds-link]', host: {
                        '[class.ds-link]': 'true',
                        '[class.ds-pointer]': 'true',
                        '[class.d-inline-flex]': 'true',
                        '[class.outline-none]': 'true',
                        '[class.mw-100]': 'true',
                        '[class.-cta]': 'variant === "cta"',
                        '[class.-icon]': 'variant === "icon"',
                        '[class.-disabled]': 'disabled',
                        '[class.-selected]': 'selected',
                        '[class.text-no-decoration]': 'true',
                        '[attr.aria-current]': 'selected ? "page" : null',
                        '[attr.disabled]': 'disabled || null',
                        '[attr.aria-disabled]': 'disabled ? disabled.toString() : null',
                        '[attr.tabindex]': 'disabled ? -1 : tabIndex ||  0',
                        '[attr.role]': '"link"',
                    }, encapsulation: ViewEncapsulation.None, template: "<span class=\"ds-link__container d-flex align-items-center\">\n  <span\n    class=\"ds-link__wrapper d-inline-block text-button\"\n    [ngClass]=\"{ 'text-bold': selected }\"\n    role=\"text\"\n  >\n    <ng-content select=\".left\"></ng-content>\n    <span class=\"ds-link__copy\">\n      <ng-content></ng-content>\n      <span *ngIf=\"a11yDescription\" class=\"sr-only\">{{ a11yDescription }}</span>\n    </span>\n    <ng-content select=\".right || ds-icon\"></ng-content>\n    <ds-icon *ngIf=\"showIcon()\" class=\"right\" name=\"right\"></ds-icon>\n  </span>\n</span>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1.WindowService }, { type: i2.FocusMonitor }]; }, propDecorators: { variant: [{
                type: Input
            }], disabled: [{
                type: Input
            }], selected: [{
                type: Input
            }], tabIndex: [{
                type: Input
            }], a11yDescription: [{
                type: Input
            }], iconRef: [{
                type: ContentChild,
                args: [IconComponent, { static: false }]
            }], onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }], handleClick: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }] } });

class LinkModule {
}
LinkModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: LinkModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
LinkModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: LinkModule, declarations: [LinkComponent], imports: [CommonModule, IconModule], exports: [LinkComponent] });
LinkModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: LinkModule, imports: [[CommonModule, IconModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: LinkModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [LinkComponent],
                    imports: [CommonModule, IconModule],
                    exports: [LinkComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { LinkComponent, LinkModule };
